<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ico"
    viewBox="0 0 16 16"
    role="img"
    aria-labelledby="GithubIcoTitle"
  >
    <title id="GithubIcoTitle">GitHub logo</title>
    <path
      stroke="none"
      fill-rule="evenodd"
      d="M8 0C3.6 0 0 3.6 0 8c0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4v-1.4c-2.2.5-2.7-1.1-2.7-1.1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.2 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6 0 1.3-.1 2-.1s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.3.6.8.6 1.5v2.2c0 .2.1.5.6.4C13.7 14.5 16 11.5 16 8c0-4.4-3.6-8-8-8z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'GithubIcon',
}
</script>
